import { FieldNames } from 'Constants/FieldNames'
import { ACCEPTED_FILES_DOCUMENTS, MAX_SIZE_DOCUMENTS, UploadSetting } from 'Pages/ibro'

export const getLimitUploadSetting = (fileType: FieldNames): UploadSetting => {
	switch (fileType) {
		case FieldNames.ANKETAFSC:
			return new UploadSetting('.xlsx', 1024 * 1024)
		case FieldNames.NEWGUARANTEEBLANK:
			return new UploadSetting('.doc,.docx', 1024 * 1024)
		case FieldNames.GENDIRSCAN:
		case FieldNames.IPSCAN:
		case FieldNames.EGRUL:
			return new UploadSetting('.pdf,.zip,.rar', 5 * 1024 * 1024)
		case FieldNames.PROTOCOLGENDIRSCAN:
		case FieldNames.FINANCIALSTATEMENT:
			return new UploadSetting('.jpg,.jpeg,.png,.pdf,.zip,.rar', 5 * 1024 * 1024)
		case FieldNames.BIGDEALPROTOCOL:
			return new UploadSetting('.jpg,.jpeg,.png,.pdf,.zip,.rar', 5 * 1024 * 1024)
		case FieldNames.USTAV:
			return new UploadSetting('.pdf,.zip,.rar', 15 * 1024 * 1024)
		case FieldNames.OTHERDOCS:
		case FieldNames.SUPPORTDOC:
			return new UploadSetting(
				'.jpg,.jpeg,.png,.pdf,.xps,.doc,.docx,.rtf,.odt,.ods,.txt,.xls,.xlsx,.zip,.rar',
				15 * 1024 * 1024
			)
		case FieldNames.FILE:
			return new UploadSetting('.jpg,.jpeg,.jpe,.png,.pdf,.tiff', 2 * 1024 * 1024)
		default:
			return new UploadSetting(ACCEPTED_FILES_DOCUMENTS, MAX_SIZE_DOCUMENTS)
	}
}
